// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2OihT","header":"ClearentDisclaimer_header__FpmsO","inner":"ClearentDisclaimer_inner__3vkP-"};